import { createApp } from 'vue'

import App from './App.vue'
import { setupAuth } from './auth'
// import auth from './auth'
import { store } from './store'
import filters from './filters'
import './styles.css'

const app = createApp(App)
app.config.globalProperties.$filters = filters
app.use(store)

setupAuth().then((auth) => {
  app.use(auth).mount('#app')
})
